import {EnsembleListenerModeCd} from '../';
import {EnumHelper} from './enum-helper';

export class EnsembleListenerModeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in EnsembleListenerModeCd ) {
      this._values.push(EnsembleListenerModeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): EnsembleListenerModeCd {

    for ( const obj in EnsembleListenerModeCd ) {
      if (EnsembleListenerModeCd[obj] === value){
        return EnsembleListenerModeCd[obj] as EnsembleListenerModeCd;
      }
    }
  }
}

const EnsembleListenerModeCdHelper = new EnsembleListenerModeCdHelperEnumHelperClass();
export default EnsembleListenerModeCdHelper;
